import Api, { apiAction } from '../api'
import { ActionTypes } from '../constants'
import _ from 'lodash'

function classesRequest() {
  return {
    type: ActionTypes.CLASSES_REQUEST
  }
}

function classesReceived(response) {
  return {
    type: ActionTypes.CLASSES_RECEIVING_SUCCESS,
    classes: response.data,
    updatedOn: Date.now()
  }
}

function classesReceivingFailure(error) {
  return {
    type: ActionTypes.CLASSES_RECEIVING_FAILURE,
    error: error
  }
}

function shouldFetchClasses(state) {
  const {
    teachers: {
      classes: { objects, updatedOn, fetching, didInvalidate }
    }
  } = state

  if (fetching) {
    return false
  } else if (_.isEmpty(objects)) {
    return true
  } else if (didInvalidate) {
    return true
  } else {
    return !updatedOn || (new Date() - updatedOn) > 60000
  }
}

function fetchClasses() {
  return apiAction({
    requestor: () => Api.teachers.classes.index(),
    onBeforeSend: classesRequest,
    onSuccess: (response) => classesReceived(response),
    onFailure: (error) => classesReceivingFailure(error)
  })
}

export function fetchClassesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchClasses(getState())) {
      return dispatch(fetchClasses())
    }
  }
}

function addLearnerRequest(classId, object) {
  return {
    type: ActionTypes.ADD_LEARNER_REQUEST,
    object: object,
    classId: classId
  }
}

function addLearnerSuccess(classId, response) {
  return {
    type: ActionTypes.ADD_LEARNER_SUCCESS,
    object: response.data,
    classId: classId
  }
}

function addLearnerFailure(classId, error) {
  return {
    type: ActionTypes.ADD_LEARNER_FAILURE,
    error: error,
    classId: classId
  }
}

export const addLearner = (classId, payload) => {
  let { name, surname, gender } = payload
  return apiAction({
    requestor: () => Api.teachers.learners({ class_id: classId }).create({ name, surname, gender }),
    onBeforeSend: () => addLearnerRequest(classId, payload),
    onSuccess: (response) => addLearnerSuccess(classId, response),
    onFailure: (error) => addLearnerFailure(classId, error)
  })
}

function updateLearnerRequest(classId, child) {
  return {
    type: ActionTypes.UPDATE_LEARNER_REQUEST,
    object: child,
    classId: classId
  }
}

function updateLearnerSuccess(classId, response) {
  return {
    type: ActionTypes.UPDATE_LEARNER_SUCCESS,
    object: response.data,
    classId: classId
  }
}

function updateLearnerFailure(classId, object, error) {
  return {
    type: ActionTypes.UPDATE_LEARNER_FAILURE,
    object: object,
    error: error,
    classId: classId
  }
}

export function updateLearner(classId, payload) {
  return (dispatch, getState) => {
    let { id, name, surname, gender, login, password } = payload
    let { teachers: { classes: { objects } } } = getState()

    let group = objects[classId]
    let learner = group.students[id].object

    return dispatch(
      apiAction({
        requestor: () => {
          return Api.teachers.learners({ class_id: classId })
                    .patch({ id }, { name, surname, gender, login, password })
        },
        onBeforeSend: () => updateLearnerRequest(classId, learner),
        onSuccess: (response) => updateLearnerSuccess(classId, response),
        onFailure: (error) => updateLearnerFailure(classId, learner, error)
      })
    )
  }
}

function deleteLearnerRequest(classId, object) {
  return {
    type: ActionTypes.DESTROY_LEARNER_REQUEST,
    object: object,
    classId: classId
  }
}

function deleteLearnerSuccess(classId, object, response) {
  return {
    type: ActionTypes.DESTROY_LEARNER_SUCCESS,
    object: object,
    classId: classId
  }
}

function deleteLearnerFailure(classId, object, error) {
  return {
    type: ActionTypes.DESTROY_LEARNER_FAILURE,
    object: object,
    error: error,
    classId: classId
  }
}

export function deleteLearner(classId, id) {
  return (dispatch, getState) => {
    let { teachers: { classes: { objects } } } = getState()

    let group = objects[classId]
    let learner = group.students[id].object

    return dispatch(
      apiAction({
        requestor: () => Api.teachers.learners({ class_id: classId }).delete({ id }),
        onBeforeSend: () => deleteLearnerRequest(classId, learner),
        onSuccess: (response) => deleteLearnerSuccess(classId, learner, response),
        onFailure: (error) => deleteLearnerFailure(classId, learner, error)
      })
    )
  }
}

function statisticsRequest(group, tour) {
  return {
    type: ActionTypes.CLASS_STATISTICS_REQUEST,
    group: group,
    tour: tour
  }
}

function statisticsReceived(group, tour, response) {
  return {
    type: ActionTypes.CLASS_STATISTICS_RECEIVING_SUCCESS,
    group: group,
    tour: tour,
    statistics: response.data,
    updatedOn: Date.now()
  }
}

function statisticsReceivingFailure(group, tour, error) {
  return {
    type: ActionTypes.CLASSES_RECEIVING_FAILURE,
    group: group,
    tour: tour,
    error: error
  }
}

function fetchStatistics(classId, tour) {
  return (dispatch, getState) => {
    let { teachers: { classes: { objects } } } = getState()
    let group = objects[classId]

    return dispatch(
      apiAction({
        requestor: () => Api.teachers.statistics({ class_id: classId, tour: tour }).index(),
        onBeforeSend: () => statisticsRequest(group, tour),
        onSuccess: (response) => statisticsReceived(group, tour, response),
        onFailure: (error) => statisticsReceivingFailure(group, tour, error)
      })
    )
  }
}

function shouldFetchStatistics(state, classId, tour) {
  let { teachers: { classes: { objects } } } = state
  let group = objects[classId]
  let statistics = group.statistics[tour]

  if (!statistics) { return true }

  let { object, updatedOn, fetching, didInvalidate } = statistics

  if (fetching) {
    return false
  } else if (!object || _.isEmpty(object)) {
    return true
  } else if (didInvalidate) {
    return true
  } else {
    return !updatedOn || (new Date() - updatedOn) > 60000
  }
}

export function fetchStatisticsIfNeeded(classId, tour) {
  return (dispatch, getState) => {
    if (shouldFetchStatistics(getState(), classId, tour)) {
      return dispatch(fetchStatistics(classId, tour))
    }
  }
}

function updateProfileRequest() {
  return { type: ActionTypes.UPDATE_TEACHER_PROFILE_REQUEST }
}

function updateProfileError(error) {
  return {
    type: ActionTypes.UPDATE_PARENT_TEACHERE_FAILURE,
    error: error
  }
}

function updateProfileSuccess(response) {
  return {
    type: ActionTypes.UPDATE_PARENT_TEACHERE_SUCCESS,
    user: new User(response.data)
  }
}

export const updateProfile = ({ name, surname, middleName, phone }) => {
  const payload = { name, surname, phone, middle_name: middleName }
  return apiAction({
    requestor: () => Api.teachers.profile.patch({ id: null }, payload),
    onBeforeSend: updateProfileRequest,
    onSuccess: (response) => updateProfileSuccess(response),
    onFailure: (error) => updateProfileError(error)
  })
}

function createClassRequest() {
  return { type: ActionTypes.CREATE_CLASS_REQUEST }
}

function createClassError(error) {
  return {
    type: ActionTypes.CREATE_CLASS_FAILURE,
    error: error
  }
}

function classCreated(response) {
  return {
    type: ActionTypes.CREATE_CLASS_SUCCESS,
    object: response.data,
    updatedOn: Date.now()
  }
}

export function createClass({ grade, name }) {
  return apiAction({
    requestor: () => Api.teachers.classes.create({ grade, name }),
    onBeforeSend: createClassRequest,
    onSuccess: (response) => classCreated(response),
    onFailure: (error) => createClassError(error)
  })
}

function diplomasRequest(group, event) {
  return {
    type: ActionTypes.CLASS_DIPLOMAS_REQUEST,
    group: group,
    event: event
  }
}

function diplomasReceived(group, event, response) {
  return {
    type: ActionTypes.CLASS_DIPLOMAS_RECEIVING_SUCCESS,
    group: group,
    diplomas: response.data,
    event: event,
    updatedOn: Date.now()
  }
}

function diplomasReceivingFailure(group, event, error) {
  return {
    type: ActionTypes.CLASS_DIPLOMAS_RECEIVING_FAILURE,
    event: event,
    group: group,
    error: error
  }
}

function fetchDiplomas(classId, event) {
  return (dispatch, getState) => {
    let { teachers: { classes: { objects } } } = getState()
    let group = objects[classId]

    return dispatch(
      apiAction({
        requestor: () => Api.teachers.diplomas({ class_id: classId, event }).index(),
        onBeforeSend: () => diplomasRequest(group, event),
        onSuccess: (response) => diplomasReceived(group, event, response),
        onFailure: (error) => diplomasReceivingFailure(group, event, error)
      })
    )
  }
}

function shouldFetchDiplomas(state, classId, event) {
  let { teachers: { classes: { objects } } } = state
  let group = objects[classId]
  let diplomas = group.diplomas[event]

  if (!diplomas) { return true }

  let { object, updatedOn, fetching, didInvalidate } = diplomas

  if (fetching) {
    return false
  } else if (!object) {
    return true
  } else if (didInvalidate) {
    return true
  } else {
    return !updatedOn || (new Date() - updatedOn) > 60000
  }
}

export function fetchDiplomasIfNeeded(classId, event) {
  return (dispatch, getState) => {
    if (shouldFetchDiplomas(getState(), classId, event)) {
      return dispatch(fetchDiplomas(classId, event))
    }
  }
}
